import { indexData } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; border: string; hover: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    border: 'hover:border-primary-200/60',
    hover: 'group-hover:bg-primary-50',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    border: 'hover:border-accent-200/60',
    hover: 'group-hover:bg-accent-50',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    border: 'hover:border-secondary-200/60',
    hover: 'group-hover:bg-secondary-50',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">专题合集</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item) => {
            const colors = colorMap[item.color] || colorMap.primary;
            return (
              <div
                key={item.id}
                className={`group bg-background-50 rounded-xl p-5 border border-background-200/60 ${colors.border} transition-all duration-200 cursor-pointer ${colors.hover}`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${colors.bg} ${colors.text} shrink-0`}>
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-base text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500">{item.count.toLocaleString()} 篇内容</span>
                  </div>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}